module.exports = {
    nullTips: 'User name and password can not be null.',
    userName: 'User Name',
    userLoginAcc: 'Login Account (id)',
    password: 'Password',
    login: 'Login',
    veriCode: 'Captcha',
    inputCodeTips: 'Please input verification code.',
    clickToRefresh: 'Click to refresh',
    INVALID_VERI_CODE: 'Verification code is invalid.',
    INVALID_USER_OR_PWD: 'Invalid user or password.',
    loginException: 'Login exception. Please open browser console to see more information, and contact the administrator.',
    loginDevTips: 'This is in preview mode.',
    BEFORE_LOGIN_SYNTAX_ERR: '[Dev Error] The before login function has syntax error: ',
    LOGIN_SYNTAX_ERR: '[Dev Error] The login function has syntax error: ',
    AFTER_LOGIN_SYNTAX_ERR: '[Dev Error] The after login function has syntax error: ',
    BEFORE_LOGIN_ERROR: '[Dev Error] Error occurred when executing before function. Caused by: ',
    LOGIN_ERROR: '[Dev Error] Error occurred when executing login function. Caused by: ',
    AFTER_LOGIN_ERROR: '[Dev Error] Error occurred when executing after login function. Caused by: ',
    beforeLoginScriptError: '[Dev Error] The before login script has syntax error: {{reason}}',
    afterLoginScriptError: '[Dev Error] The after login script has syntax error: {{reason}}',
    exeBeforeLoginScriptError: '[Dev Error] Error occrred when executing before login script: {{reason}}',
    exeAfterLoginScriptError: '[Dev Error] Error occrred when executing after login script: {{reason}}'
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/i18n/locale.en.js
// module id = 5
// module chunks = 0